export default __webpack_public_path__ + "static/media/data-white-db.da4cf79c.svg";